import type { SSEEvent } from "../hooks/use-sse";

export const REQUEST_DETAIL_REFRESH_EVENTS = [
  "request.verified_access",
  "request.viewed",
  "request.signed",
  "request.declined",
  "request.expired",
  "request.revoked",
  "request.signing_progress",
] as const;

export const DASHBOARD_REFRESH_EVENTS = [
  "request.created",
  "request.sent",
  "request.verified_access",
  "request.viewed",
  "request.signed",
  "request.declined",
  "request.revoked",
  "request.expired",
] as const;

const requestDetailRefreshEvents = new Set<string>(REQUEST_DETAIL_REFRESH_EVENTS);
const dashboardRefreshEvents = new Set<string>(DASHBOARD_REFRESH_EVENTS);

export function shouldRefreshRequestDetailForEvent(
  event: SSEEvent,
  currentRequestId: string | undefined,
): boolean {
  return !!currentRequestId
    && requestDetailRefreshEvents.has(event.type)
    && event.requestId === currentRequestId;
}

export function shouldRefreshDashboardForEvent(event: SSEEvent): boolean {
  return dashboardRefreshEvents.has(event.type);
}

export function getNotificationRequestId(event: SSEEvent): string | null {
  return event.requestId ?? null;
}

export function isFullySignedEvent(event: SSEEvent): boolean {
  return event.type === "request.signed" && event.data.allComplete === true;
}

export function isPositiveNotificationEvent(event: SSEEvent): boolean {
  return event.type === "request.signed" || event.type === "user.first_send_completed";
}
